<template>
    <div class="bg-[#010101] w-[100px] h-[100vh]">
        <div class="mt-[20px]">
            <img src="../assets/logo.svg" class="w-[100px] h-[50px]">
        </div>
        <div>
            <div 
                v-for="tab in menuTabs" 
                @click="chooseInMenu(tab)" 

                class="text-white text-center mt-[25px] py-[0.7vh] cursor-pointer text-sm select-none items-center"

                :class="
                    {
                        'bg-gradient-to-l from-[#D9D9D93D]' : route.path == tab.path,
                    }
                    " 
            >
                <div class="flex items-center justify-center">
                    <img :src="tab.icon" class="mx-[0.2vw] w-[25px]">
                </div>
            </div>
            <div @click="logout" class="mt-[10vw] flex justify-center cursor-pointer">
                <img src="../assets/logout_icon.svg" class="w-[25px]">
            </div>
        </div>

    </div>
</template>

<script>
    import { ref, watch } from 'vue'
    import { uuid } from 'vue3-uuid'
    import { useRoute, useRouter } from 'vue-router'
    import { useMainStore } from '../stores/mainStore'

    export default {
        setup() {
            const route = useRoute()
            const router = useRouter()
            const store = useMainStore()
            const updateKey = ref(uuid.v1())

            // {
            //     path: '/',
            //     name: 'Показники',
            //     icon: require('../assets/sidebar_icons/dashboard_icon.svg')
            // },

            const menuTabs = [
                {
                    path: '/students',
                    name: 'Учні',
                    icon: require('../assets/sidebar_icons/players_icon.svg')
                },
                {
                    path: '/groups',
                    name: 'Групи',
                    icon: require('../assets/sidebar_icons/groups_icon.svg')
                },
                {
                    path: '/trainings',
                    name: 'Календар',
                    icon: require('../assets/sidebar_icons/calendar_icon.svg')
                },
                {
                    path: '',
                    name: 'Тренувальний процес',
                    icon: require('../assets/icons/sidebar_icons/finance_icon.svg'),
                    innerPages: [
                        {
                            path: '/training-programs',
                            name: 'Програми'
                        },
                        {
                            path: '/training-elements',
                            name: 'Елементи'
                        },
                        {
                            path: '/trainings-constructor',
                            name: 'Тренування'
                        },
                        {
                            path: '/training-schemes',
                            name: 'Редактор схем'
                        }
                    ],
                    innerPagesView: false
                },
                {
                    path: "",
                    name: "Матч-центр",
                    icon: require('../assets/refactored_assets/img/menu/training_programs_icon.svg'),
                    isActive: false,
                    innerPages: [
                        {
                            path: "/match-center/matches",
                            name: "Матчі",
                            isActive: false,
                        },
                        {
                            path: "/match-center/teams",
                            name: "Команди та ліги",
                            isActive: false,
                        },
                    ],
                    innerPagesView: false
                },
            ]

            const restrictedPaths = ['/training-programs', '/training-schemes']

            watch(() => store.trainer?.position, (position) => {
                const pos = (position || '').toLowerCase()
                if (pos.includes('goalkeeper_trainer') || pos.includes('individual_trainer')) {
                    const trainingProcess = menuTabs.find(item => item.innerPages)
                    if (trainingProcess) {
                        trainingProcess.innerPages = trainingProcess.innerPages.filter(page =>
                            !restrictedPaths.includes(page.path)
                        )
                    }
                }
            }, { immediate: true })

            const logout = () => {
                localStorage.removeItem('access_token')
                localStorage.removeItem('refresh_token')
                router.go()
            }

            const chooseInMenu = (tab) => {
                for (let i = 0; i < menuTabs.length; i++) {
                    menuTabs[i].innerPagesView = false
                }
                if (tab.innerPages) {
                    tab.innerPagesView = true
                    updateKey.value = uuid.v1()
                } else {
                    router.push(tab.path)
                }
            }

            return {
                route,
                router,
                menuTabs,
                logout,
                chooseInMenu,
                updateKey
            }
        }
    }
</script>

<style>

    .logo-place {
        box-shadow: inset -5px 0px 10px 3px rgba(0, 0, 0, .4);
    }

</style>